import type { ApolloClient } from '@apollo/client';

const PURCHASE_AFFECTED_FIELDS = ['loanTransactions', 'creditUtilization'];

export const invalidateAfterSimulatedPurchase = ({ cache }: ApolloClient<object>) => {
  PURCHASE_AFFECTED_FIELDS.forEach((fieldName) => {
    cache.evict({ id: 'ROOT_QUERY', fieldName });
  });

  cache.gc();
};
